import { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import { ICE_BREAKING_TIPS } from '@packages/shared/core/common/constants';
import ChatInput, { ChatInputRefProps } from '../ChatInput';
import ChatFooterIceBreakingTipsDesktop from '../ChatFooterIceBreakingTipsDesktop';
import ChatFooterIceBreakingTipsMobile from '../ChatFooterIceBreakingTipsMobile';
import styles from './ChatFooter.module.scss';

export type ChatFooterProps = {
  className?: string;
  onChange: (value: string) => void;
  onSelectIceBreakingTip: (text: string) => void;
  value: string;
  onSendMessage: () => void;
};

const ChatFooter = forwardRef<ChatInputRefProps, ChatFooterProps>(
  ({ className = '', value, onChange, onSendMessage, onSelectIceBreakingTip }: ChatFooterProps, inputRef) => {
    const selectedIceBreakingTip = useMemo(() => {
      if (!value) return '';

      const foundSelectedTip = ICE_BREAKING_TIPS.find((tip) => value.includes(tip));
      return foundSelectedTip || '';
    }, [value]);

    const chatInputWrapperClasses = cn({
      [styles.root]: true,
      [styles.chatInputWrapper]: true,
      [className]: !!className,
    });

    return (
      <div className={chatInputWrapperClasses}>
        <ChatFooterIceBreakingTipsDesktop
          className={cn(styles.chatIcebreakers, styles.desktop)}
          tips={ICE_BREAKING_TIPS}
          selectedTip={selectedIceBreakingTip}
          onSelectTip={onSelectIceBreakingTip}
        />

        <ChatFooterIceBreakingTipsMobile
          className={cn(styles.chatIcebreakers, styles.mobile)}
          tips={ICE_BREAKING_TIPS}
          selectedTip={selectedIceBreakingTip}
          onSelectTip={onSelectIceBreakingTip}
        />

        <ChatInput
          className={styles.chatInput}
          ref={inputRef}
          value={value}
          onChange={onChange}
          onSubmit={onSendMessage}
        />
      </div>
    );
  },
);

export default ChatFooter;
